import { memo } from "react";
import { useEffect } from "react";
import { useSelector } from 'react-redux'
import MainApp from "./Main";
import AuthApp from "@mods/userManagement/auth/routes";
import { applyBranding, loadBranding, BRANDING_UPDATED } from "@utils/branding";

const App = () => {

  // // Set the desired timezone
  // const timeZone = 'Europe/London'; // Replace with the desired timezone
  // moment.tz.setDefault(timeZone);

  useEffect(() => {
    // Applies the cached branding straight away, then refreshes from the API.
    //
    // This used to read localStorage once at module scope and set the title in a
    // []-dep effect, so on a first visit — when nothing was cached yet — the tab
    // stayed on "Loading" until you manually refreshed the page.
    loadBranding();

    // Keeps the tab in step when branding changes mid-session: the login page
    // caching it for the first time, or an admin saving CRM settings.
    const onBrandingUpdated = (event) => applyBranding(event.detail);
    window.addEventListener(BRANDING_UPDATED, onBrandingUpdated);

    return () => window.removeEventListener(BRANDING_UPDATED, onBrandingUpdated);
  }, []);

  const authUser = useSelector((state) => state.auth.authUser);

  return (
    authUser && authUser.id ? <MainApp /> : <AuthApp />
  );

}

export default memo(App);
